import * as React from "react";
import get from "lodash/get";

import "./PendingRewards.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { StoreState } from "../../reducers";

export interface PendingRewardsProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  rewardStats: StoreState["reward"]["rewardStats"];
}

export class PendingRewards extends ComponentBase<PendingRewardsProps> {
  // tslint:disable:cyclomatic-complexity
  render() {
    const {
      style,
      classNames,
      rewardStats,
      action,
      successScreen,
      mode,
      isEditing,
    } = this.props;
    const pendingRewards = get(rewardStats, "pendingCredits");

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={`PendingRewards-text  PendingRewards-mode-${
          mode || "default"
        } ${classNames || ""} ${
          !isEditing ? "PendingRewards-text-preview" : ""
        } ${this.state.animationClass}`}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {pendingRewards}
      </div>
    );
  }
}
